import { motion } from 'framer-motion';

import { Link } from 'react-router-dom';
import {
  LoginContainer,
} from './styles';

// import busGif from '../../assets/images/busGif.gif';
import logo from '../../assets/images/Logo.svg';
import loginLottie from '../../assets/lotties/loginLottie.json';

import Lottie from 'lottie-react';
import Button from '../../components/Button';
import FilterRadioButton from '../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../components/FilterRadioButtonsContainer';
import { ButtonContainer } from '../../components/Form';
import FormGroup from '../../components/FormGroup';
import Input from '../../components/Input';
import Loader from '../../components/Loader';
import PasswordInputFormGroup from '../../components/PasswordInputFormGroup';
import useLogin from './useLogin';

export default function Login() {
  const {
    isLoading,
    context,
    handleLoginTypeChange,
    loginType,
    getErrorMessageByFieldName,
    login,
    handleLoginChange,
    cpf,
    handleCpfChange,
    email,
    handleEmailChange,
    password,
    handlePasswordChange,
    handleLogin,
    isFormValid,
  } = useLogin();
  return (
    <>
      <Loader isLoading={isLoading || context.isLoading} />
      <LoginContainer>
        <div className="asideGif">
          {/* <img src={busGif} alt="busGif" /> */}
          <Lottie animationData={loginLottie} loop={true} />
        </div>

        <div className="asideLogin">
          <div className="loginTitle">
            <div className="labelTitle">
              <div>
                Bem-vindo ao Sismob!
              </div>
              <div className="subtitle">
                Realize abaixo seu login para acessar o sistema.
              </div>
            </div>
            <img src={logo} alt="logo" />
          </div>

          <div className="signup">
            <span>
              Primeiro acesso?
            </span>
            <Link to="/signup"> Cadastre-se aqui!</Link>
          </div>

          <div className="loginType">
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                onClick={() => handleLoginTypeChange('cpf')}
                selected={loginType === 'cpf'}
              >
                Entrar com CPF
              </FilterRadioButton>
              <FilterRadioButton
                onClick={() => handleLoginTypeChange('username')}
                selected={loginType === 'username'}
              >
                Entrar com nome de usuário
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </div>

          <div className="loginForm">
            <div className="loginInput">
              {loginType === 'username' && (
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: false }}
                  transition={{ delay: 0.1, type: 'tween', stiffness: 10000 }}
                >
                  <FormGroup error={getErrorMessageByFieldName('username')}>
                    <label htmlFor="login">Login (nome de usuário)</label>
                    <Input
                      error={getErrorMessageByFieldName('username')}
                      placeholder="Informe seu nome de usuário"
                      value={login}
                      onChange={handleLoginChange}
                      autoComplete="new-password"
                    />
                  </FormGroup>
                </motion.div>
              )}

              {loginType === 'cpf' && (
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: false }}
                  transition={{ delay: 0.1, type: 'tween', stiffness: 10000 }}
                >
                  <FormGroup error={getErrorMessageByFieldName('cpf')}>
                    <label htmlFor="login">Login (CPF)</label>
                    <Input
                      maxLength={14}
                      error={getErrorMessageByFieldName('cpf')}
                      placeholder="Informe seu CPF"
                      value={cpf}
                      onChange={handleCpfChange}
                      autoComplete="new-password"
                    />
                  </FormGroup>
                </motion.div>
              )}

              {loginType === 'email' && (
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: false }}
                  transition={{ delay: 0.1, type: 'tween', stiffness: 10000 }}
                >
                  <FormGroup error={getErrorMessageByFieldName('email')}>
                    <label htmlFor="login">Login (E-mail)</label>
                    <Input
                      error={getErrorMessageByFieldName('email')}
                      placeholder="Informe seu e-mail de acesso"
                      value={email}
                      onChange={handleEmailChange}
                      autoComplete="new-password"
                    />
                  </FormGroup>
                </motion.div>
              )}
            </div>

            <div className="passwordInput">
              <PasswordInputFormGroup
                label='Senha'
                value={password}
                onChange={handlePasswordChange}
                error={getErrorMessageByFieldName('password')}
              />
            </div>
          </div>

          <ButtonContainer flexDirection='column'>
            <Button type="button" onClick={handleLogin} disabled={!isFormValid}>
              Acessar
            </Button>
            <div className="forgotPassword">
              <Link to="/forgot">Esqueci minha senha</Link>
            </div>
          </ButtonContainer>
        </div>
      </LoginContainer>
    </>
  );
}
